import React, {
    useState,
    useEffect,
    useContext,
    Children,
} from 'react';
import { ApolloProvider, gql } from '@apollo/client';
import PropTypes from 'prop-types';

import { setDefaultLocale } from 'app/utils/date';

import apolloClient from 'app/apollo/client';
import { AuthContainer } from 'app/containers/AuthContainer';
import SPAProvider, { SPA_MODE_OFF } from 'app/containers/SPAProvider';
import LocaleProvider from 'app/containers/LocaleProvider';
import { OverlayProvider } from 'app/containers/contexts/overlay.context';
import { DataSaverUser } from 'app/containers/DataSaverUser';
import LocationProvider from 'app/containers/LocationProvider';
import OverlaysContainer from 'app/components/OverlaysContainer';
import { AchievementsOpener } from 'app/components/Achievements/AchievementsOpener';
import { AchievementsBannerBig } from 'app/components/Achievements/AchievementsBannerBig';


import { fragmentRegistry } from 'app/apollo/fragmentRegistry';
import { ABTestDataProvider } from 'app/containers/contexts/abTest.context';
import { VideoSliderPortalGlobal } from 'global/compoents/VideoSlider/VideoSlider';
import { VideoCardsSliderPortal } from 'global/compoents/VideoCardsSlider/VideoCardsSlider';
import { OfferOpener } from 'app/components/OfferGuard';
import { CookiesNotification } from 'app/components/ui/CookiesNotification/CookiesNotification';
import { useAppDataFetchingState } from 'app/AppDataAccessContainer';
import { useToggleSubscription } from 'app/hooks/useToggleSubscription';
import { getPaymentMethodAndType } from 'app/containers/BasketResolver';
import { promocodeVar } from 'app/apollo/reaction';
import { NY26Ball } from 'global/compoents/NY26Ball';
import { EasterBall } from 'global/compoents/EasterBall';
import { UserProvider } from './UserProvider';
import BillingProvider from './BillingProvider';
import { BasketProvider } from './BasketProvider';
import { ConfigContext, ConfigProvider } from './ConfigProvider';
import { FiltersProvider } from './FiltersProvider';
import { MenuDishesProvider } from './PromoCheckoutMenuDishesProvider';
import { PromoCheckoutMenuDishesAdapter } from './PromoCheckoutMenuDishesAdapter';
import { LandingEnvDataSaver } from './LandingEnvDataSaver';
import { DishDetailsContextProvider } from './DishDetailsContainer/DishDeltailsContextProvider';

import AvailableLinksLandingAdapter from './AvailableLinksLandingAdapter';

import { LoadingContainer } from './LoadigPage/LoadingContainer';
import { NavigationPortal } from './Navigation';

import MobileSiteNav from './MobileSiteNav';
import Order from './Order';
import AgeGate from './AgeGate';
import { BasketTotalPortal } from './BasketTotalPortal';

import locales from '../locales';
import PromoHeader from './header';
import { NYGiftProvider } from './NYGiftContext';
import { QuestionsAndFeedbackBlocks } from './Like5x2page';
import { DishLayoutIsolatedButton } from './Dish/DishLayoutIsolatedButton/DishLayoutIsolatedButton';
import { CookiesNotificationPromoCheckoutGuard } from './CookiesNotificationPromoCheckoutGuard';


const AGE_GATE = 'ageGate';
const RESOLVED = 'resolved';


// ROOT_MENU_DISH_ITEM
fragmentRegistry.register(gql`
    fragment ROOT_MENU_DISH_ITEM on menuDish{
        id
        title
        titleEn
        caption
        captionEn
        cooking_time
        cook_until
        composition
        weight
        price
        portions
        previewImage
        previewMobileImage
        verticalImage
        umAlias
        categoryId: category_id
        partnersComment
        parentId
        # BR-1104
        secondDishPart
        replaceableIngredient
        nutrition {
            carbohydrate {
                title
                value
                unit
            }
            fat {
                title
                value
                unit
            }
            protein {
                title
                value
                unit
            }
            calories {
                title
                value
                unit
            }
        }
        tags {
            id
            erp_id
            title
            category_id
            category_name
        }
        metaLabel @client
    }
`);

// ROOT_CART_DISH_ITEM
fragmentRegistry.register(gql`
    fragment ROOT_CART_DISH_ITEM on cartItem {
        dish_id
        type
        portions
        price
        discount_price
        promoDiscountPrice
        is_promo
        has_crossed_out_price
    }
`);

// ROOT_CART_TOTAL
fragmentRegistry.register(gql`
    fragment ROOT_CART_TOTAL on cartTotal {
        # Легаси поля, от которых нужно отказаться
        total_price
        total_discount_price
        total_common_price
        delivery_price
        promocode_applied
        promocode_amount
        discount_amount
        static_discount_price
        static_common_price
        referral_amount
        # FRNT-2607
        # Новые поля, на которые нужно перейти и отказаться от использования полей выше
        dishesPrice
        deliveryPrice
        subscriptionDiscountAmount
        promocodeDiscountAmount
        specialDiscountAmount
        subscriptionPrice
        onlinePrice
        cashPrice
    }
`);

// ROOT_CART_DISCOUNT_CONDITIONS
fragmentRegistry.register(gql`
    fragment ROOT_CART_DISCOUNT_CONDITIONS on DiscountConditions {
        promocode
        promocode_status
        isCertificate
        isPromoCodeActivated
        isPromocodeCombineWithDiscount
        isPromocodeCombineWithAccount
        differenceBetweenPromocodeAndOrder
        promoCodeApplyingErrorMessage
        isPromoCodeExists
        isSubscriptionActivated
        deliveriesCount
        discountType
        discountValue
        discountDuration
    }
`);


const PromoCheckoutMainDA = (props) => {
    const { config } = props;
    const [toggleSubsctioption] = useToggleSubscription();

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);

        if (config?.payment) {
            const promo = urlParams.has('promo_code') ? urlParams.get('promo_code') : '';
            promocodeVar(promo);
            const { type, method } = getPaymentMethodAndType(config?.payment);
            toggleSubsctioption(type, method, promo);
        }
    }, []);

    return (
        <>
            {/* HARDCODED CARDS */}
            <VideoCardsSliderPortal />
            {/* MODAL FOR YOUR CARDS */}
            <VideoSliderPortalGlobal />

            <NavigationPortal />
            <LandingEnvDataSaver />
            <MobileSiteNav />
            <Order />
            <OverlaysContainer />
            <PromoHeader />
            <BasketTotalPortal />
            <DishLayoutIsolatedButton
                nodeId="button-card-portal-desktop"
            />
            <DishLayoutIsolatedButton
                nodeId="button-card-portal-mobile"
            />
            {/* UNTIL NY 2027 */}
            {/* <AchievementsOpener>
                {({ togglePopup }) => (
                    <AchievementsBannerBig
                        onClick={togglePopup}
                    />
                )}
            </AchievementsOpener> */}
            <OfferOpener
                isScalable={false}
                realm="promo-checkout"
            />
            <QuestionsAndFeedbackBlocks />
            <CookiesNotificationPromoCheckoutGuard />
            {/* <NY26Ball
                position="withfooter"
                page="promo-checkout-page"
            /> */}
            {/* <EasterBall
                position="withfooter"
                page="promo-checkout-page"
            /> */}
        </>
    );
};

export default function PromoCheckoutApp(props) {
    const { config } = props;
    const defaultLocale = sessionStorage.getItem('lang') || 'ru';
    const [appReady, setAppReady] = useAppDataFetchingState();

    const [locale/* , setLocaleState */] = useState(defaultLocale); // en, ru
    const [isAgeGateResolved, setAgeGate] = useState(false);


    useEffect(() => {
        setDefaultLocale(defaultLocale);
    }, [defaultLocale]);

    useEffect(() => {
        if (isAgeGateResolved) {
            window.sessionStorage.setItem(AGE_GATE, RESOLVED);
        }
    }, [isAgeGateResolved]);


    const onResolveAgeGate = () => setAgeGate(true);
    const onRejectAgeGate = () => window.location.replace('/');

    const isAgeGateNeeded = config.ageGate && !isAgeGateResolved;

    return (
        <LocaleProvider locale={locale} locales={locales}>
            <SPAProvider mode={SPA_MODE_OFF}>
                <ConfigProvider config={config}>
                    <ApolloProvider client={apolloClient}>
                        {isAgeGateNeeded ? (
                            <AgeGate
                                imageUrl={config.ageGateImage}
                                onClickResolve={onResolveAgeGate}
                                onClickReject={onRejectAgeGate}
                            />
                        ) : (
                            <ABTestDataProvider>
                                <LoadingContainer>
                                    <OverlayProvider>
                                        <AuthContainer
                                            setAppReady={setAppReady}
                                            appReady={appReady}
                                        >
                                            <LocationProvider>
                                                <AvailableLinksLandingAdapter>
                                                    <FiltersProvider>
                                                        <UserProvider>
                                                            <DataSaverUser />
                                                            <MenuDishesProvider>
                                                                <BasketProvider>
                                                                    <BillingProvider>
                                                                        <PromoCheckoutMenuDishesAdapter>
                                                                            <DishDetailsContextProvider>
                                                                                <NYGiftProvider>
                                                                                    <PromoCheckoutMainDA config={config} />
                                                                                </NYGiftProvider>
                                                                            </DishDetailsContextProvider>
                                                                        </PromoCheckoutMenuDishesAdapter>
                                                                    </BillingProvider>
                                                                </BasketProvider>
                                                            </MenuDishesProvider>
                                                        </UserProvider>
                                                    </FiltersProvider>
                                                </AvailableLinksLandingAdapter>
                                            </LocationProvider>
                                        </AuthContainer>
                                    </OverlayProvider>
                                </LoadingContainer>
                            </ABTestDataProvider>
                        )}
                    </ApolloProvider>
                </ConfigProvider>
            </SPAProvider>
        </LocaleProvider>
    );
}

PromoCheckoutApp.propTypes = {
    config: PropTypes.shape({
        ageGate: PropTypes.bool,
        ageGateImage: PropTypes.string,
    }).isRequired,
};
